var data = [
  {
    lang: "en",
    page: {
      login: {
        loginbutton: "Sign In",
        resetpassword: "Forgot password?",
        empty: "Your username or password cannot be none",
        enterUsername: "Enter username",
        enterPassword: "Enter password",
        enterOtp: "Enter OTP token",
        otpLabel: "If you do not have an OTP, leave it blank",
      },
      leftsidebar: {
        dashboard: "Dashboard",
        account: "Account",
        security: "Security",
        history: "History",
        information: "Information",
        tokenpage: "Tokenpage"
      },
      topbar: {
        signout: "Sign Out"
      },
      account: {
        email: "Email",
        username: "Username",
        datejoined: "Join Date",
        lastlogin: "Latest Sign-in",
        koreaTimezone: "Korean Time Zone",
        status: "Status",
        level: "Level",
        unableWithdraw: "Unable withdraw and send ETH",
        limitedWithdraw: "Able to send ETH, but unable to withdraw",
        higherWithdrawLimit: "Able to withdraw",
        highestWithdrawLimit: "Able to withdraw with highest limit",
        changepassword: "Change password",
        newpassword: "New password*",
        confirmpassword: "Confirm password*",
        pwNoMatch: "Password does not match",
        pwLessThan8: "Your password has to be longer than 8 characters",
        pwReset: "Your password has been updated!",
        UnKnownResult: "Unknown result",
        failed: "Failed"
      },
      history: {
        history: "history",
        noHistory: "You do not have withdraw history yet",
        hereHistory:
          "Please refresh the page to see the most updated version your status",
        date: "Date",
        status: "Status",
        token: "Token",
        amount: "Amount",
        address: "TransactionHash"
      },
      notification: {
        whatisDao: "Q.What is Dao?",
        explainDao:
          "A. DAO is a utility token. Having DAO token in this wallet can obtain the airdropped token in the future. The more DAO you have, the more airdropped token you will get.",
        ethforWithdraw: "Q. Do I need ethereum to withdraw?",
        explainGas:
          "A. Ethereum in this wallet can be deposit and withdraw freely without limit. Having small amount of ether in this wallet can give you the benefits of being able to immediate withdraw other airdropped token",
        airdropWithdraw: "Q. Can I deposit or withdraw airdropped token?",
        deductDao:
          "A. Airdrop tokens such as Cobinhood, Cybermiles and WandX are withdraw only and can not be deposit. However once you withdraw any of the airdropped token, your DAO token will be deducted based on the deduction rate (deduction rate can change over time). Less DAO means less airdropped tokens in the future.",
        tokenName: "Token name",
        deductionRate: "Current Dao token deduction rate",
        noticeManualApproval:
          "Note: If you have enough Ethereum balance in your account that provide gas fee (0.005 ETH is enough), you can withdraw",
          aidaopolicy: "AiDAO Sending Policy",
        aidaosendinginfo: "AiDAO can be sent out freely without any limits. Moreover, sending AiDAO will decrease all of your airdrop token proportionally. For example, if you send out 1% of your AiDAO token. All of your airdrop token will be reduced by 1%.",
      },
      dashboard_main_content: {
        welcometoDao: "Welcome to Dao Wallet - Dao wallet team",
        notification: "Important Notification: Xinfin (XDCe) has switched to its own blockchain and is abandoning their Ethereum ERC20 equivalence at March 31, 2021. Therefore, we are no longer support XDCe. XDCe page has been taken down. We will reimburse the XDCe with an airdrop of SingularityNet tokens (AGI) worth equivalent with your previous XDCe balance."
      },
      signup: {
        signup: "Sign up",
        username: "Username",
        password: "Password",
        enterUsername: "Enter username",
        enterPassword: "Enter password",
        signin: "Sign in",
        haveAccountAlready: "I already have an account"
      },
      setup: {
        reset: "Setup Your New Username and Password",
        enterNewUsername: "Enter New Username",
        enterNewPassword: "Enter New Password",
        ConfirmNewPassword: "Confirm New Password",
        pwLessThan8: "Must be at least 8 or more characters in Length",
        save: "Save",
        signOut: "Sign out"
      },
      resetpassword: {
        sendRecoveryLink: "Send Recovery Link",
        enterEmail: "Enter email address",
        send: "send",
        backtoSignin: "Back to Sign in"
      },
      daolevel: {
        level: "level"
      },
      email_verification: {
        sendEmail: "Send Email",
        send: "Send",
        activate: "Activate",
        emailVerification: "Email Verification",
        verifyEmail: "Verify Email",
        sendVerificationEmail: "Send verification Email",
        confirmEmail: "Confirm your Email",
        enterEmail: "Enter your Email",
        failed: "Failed"
      },
      otp: {
        enabled: "Enabled",
        failed: "Failed",
        twoFaVerification: "Two-Factor Authentication",
        noticeTwoFa:
          "Using Two-factor authentication is highly recommended. Please consider our available options for increasing the security of your account. We want to give you every opportunity to be confident that your account is secure.",
        verifyGoogle2FA: "Verigy google 2FA",
        googleVerification: "Google Verification",
        firstStep: "Step 1 of 2",
        secondStep: "Step 2 of 2",
        scanQRcode: "Scan QR code with Google Authenticator",
        qrcode: "QR code",
        enterCode: "Enter the code from Google Authenticator",
        confirm: "Confirm"
      },
      pending: {
        transactionPending: "Pending transaction",
        numberofPending: "The number of pending transaction"
      },
      popup: {
        confirm: "Confirm"
      },
      send_transaction: {
        withdraw: "Withdraw",
        deductDao: "Dao token will be deducted",
        fee: "Withdrwal Fee: ",
        sendToken: "Token will be sent",
        submitting: "Submitting",
        success: "Success",
        transacionHash: "Transaction Hash: ",
        failed: "Failed",
        sending: "Sending",
        gasprice: "gasprice",
        send: "Send",
        sentSuccessfully: "TransacionHash",
        gasUsed: "Used gas : ",
        checkPending: "Check if there is any transaction pending",
        daoToken: "Dao Token",
        to: "To",
        send: "Send",
        notice: "Notice",
        withdrawDeductsDao:
          "DAO token will be deducted if you withdraw this token",
        address: "Address",
        amount: "Amount",
        gwei:
          "Please check current gas price from the link (https://ethgasstation.info/) and type the right amount of Gwei. We recommend to type slightly higher Gwei than the current price for a faster transaction.",
        otpcode: "OTP code",
        close: "Close",
        send: "Send",
        kycRequired: "KYC is required",
        daoWalletTeam: "- Dao Wallet Team",
        kycRequiredforTransaction: "KYC approval is required to send token",
        aidaosendingwarning: "Withdraw AiDAO will reduce all of your airdrop tokens by the proportion that your AiDAO withdrawal. Detail see information page.",
        deductToken: "All airdrop tokens will be deducted. Are you sure?",
      },
      wallet_address: {
        addressCopied: "Address is copied to clipboard",
        walletAddress: "Wallet Address",
        copy: "Copy"
      },
      withdraw: {
        withdraw: "Withdraw",
        daoTokenisUtilityToken:
          "Dao token is utility token for dao token holders",
        withdrawDeductsDao:
          "Dao token will be deducted if you withdraw this token",
        learnMore: "Learn more"
      },
      aidao: {
        balance: "balance",
        back: "Back to token page"
      },
      cobinhood: {
        balance: "balance",
        back: "Back to token page"
      },
      cybermiles: {
        balance: "balance",
        back: "Back to token page"
      },
      ethereum: {
        balance: "balance",
        back: "Back to token page"
      },
      dash: {
        balance: "balance",
        back: "Back to token page"
      },
      golem: {
        balance: "balance",
        back: "Back to token page"
      },
      wandx: {
        balance: "balance",
        back: "Back to token page"
      },
      xdce: {
        balance: "balance",
        back: "Back to token page"
      },
      xyo: {
        balance: "balance",
        back: "Back to token page"
      },
      swapcenter: {
        address: "Address",
        amount: "Amount",
        otpcode: "OTP code"
      },
      tokenpage: {}
    }
  },

  {
    lang: "kr",
    page: {
      login: {
        loginbutton: "로그인",
        resetpassword: "비밀번호를 잊으셨나요?",
        empty: "아이디나 비밀번호가 누락되었습니다",
        enterUsername: "아이디를 입력하세요",
        enterPassword: "비밀번호를 입력하세요",
        enterOtp: "OTP",
        otpLabel: "OTP가 없으면 빈칸으로 남겨놓으세요",
      },
      leftsidebar: {
        dashboard: "대시보드",
        account: "내 계정",
        security: "보안센터",
        history: "거래내역",
        information: "정보",
        tokenpage: "토큰 페이지"
      },
      topbar: {
        signout: "로그아웃"
      },
      account: {
        email: "이메일",
        username: "아이디",
        datejoined: "가입한 시간",
        lastlogin: "최근 로그인한 시간",
        koreaTimezone: "한국 표준시간대 기준",
        status: "상태",
        level: "레벨",
        unableWithdraw: "ETH의 출금이나 전송 불가능",
        limitedWithdraw: "ETH 전송 가능, 출금 불가능",
        higherWithdrawLimit: "출금 가능",
        highestWithdrawLimit: "최대 한도까지 출금 가능",
        changepassword: "비밀번호 변경",
        newpassword: "새 비밀번호",
        confirmpassword: "새 비밀번호 확인",
        pwNoMatch: "비밀번호가 일치하지 않습니다",
        pwLessThan8: "비밀번호는 8자리 이상이어야합니다",
        pwReset: "비밀번호가 재설정되었습니다",
        UnKnownResult: "알 수 없는 결과입니다",
        failed: "실패하였습니다"
      },
      history: {
        history: "입출금내역",
        noHistory: "아직 입출금한 내역이 없습니다",
        hereHistory: "상태를 업데이트하려면 페이지를 새로고침하세요",
        date: "시간",
        status: "상태",
        token: "토큰",
        amount: "금액",
        address: "트랜잭션 해시"
      },
      notification: {
        whatisDao: "Q.다오가 무엇인가요?",
        explainDao:
          "A. 다오는 유틸리티 토큰입니다. 다오 토큰을 가지고 있음으로서 에어드랍을 받을 수 있습니다. 에어드랍되는 토큰의 갯수는 다오토큰의 갯수에 비례합니다.",
        ethforWithdraw: "Q. 출금하려면 이더리움이 필요한가요?",
        explainGas:
          "A. 다오지갑 내에서 이더리움은 제한없이 입출금이 가능합니다. 지갑에 이더리움을 소량 입금하시면 이더리움을 사용하여 에어드랍받은 토큰을 바로 인출하실 수 있습니다.",
        airdropWithdraw: "Q. 에어드랍된 토큰의 입출금이 가능한가요?",
        deductDao:
          "A. 코빈후드, 사이버마일스, 완드엑스와 같은 에어드랍된 토큰들은 입금은 불가능합니다. 에어드랍된 토큰을 인출하는 경우에는 다오토큰이 거래수수료로서 사용되어 차감됩니다. (차감 비율은 시간에 따라 다를 수 있습니다). 다오 갯수가 적으면 추후에 에어드랍되는 토큰의 갯수도 적어집니다.",
        tokenName: "토큰",
        deductionRate: "현재 다오토큰 차감율",
        noticeManualApproval:
          "가스(0.005 ETH 면 충분합니다)를 제공해줄 수 있는 이더리움 잔고가 있으면 출금하실 수 있습니다.",
        aidaopolicy: "AiDAO 출금 정책",
        aidaosendinginfo: "AiDAO를 제한없이 출금할 수 있습니다. AiDAO를 인출하게 되면 에어드랍 받은 토큰도 이에 비례하여 줄어듭니다. 예를 들어서 1%의 AiDAO토큰을 인출하면 그만큼 에어드랍된 토큰이 1% 줄어듭니다"
      },
      dashboard_main_content: {
        welcometoDao: "다오지갑에 오신 것을 환영합니다 - 다오지갑 팀",
        notification: "중요 알림 : Xinfin (XDCe)은 자체 블록 체인으로 전환했으며 2021 년 3 월 31 일에 Ethereum ERC20 토큰인 XDCe를 삭제합니다. 즉, 더 이상 XDCe를 지원하지 않습니다. 하여 AiDAO 내의 XDCe 페이지가 삭제되었습니다. 따라서 이전 XDCe 잔액을 SingularityNet 토큰 (AGI)으로 교환, 보유하신 XDCe와 AGI의 시세에 따른 비율로 에어드랍하여 XDCe를 환급할 것입니다."
      },
      signup: {
        signup: "신규 가입",
        username: "아이디",
        password: "비밀번호",
        enterUsername: "아이디를 입력하세요",
        enterPassword: "비밀번호를 입력하세요",
        signin: "로그인",
        haveAccountAlready: "이미 계정이 있습니다"
      },
      setup: {
        reset: "아이디와 비밀번호 새로 설정",
        enterNewUsername: "새 아이디를 입력하세요",
        enterNewPassword: "새 비밀번호를 입력하세요",
        ConfirmNewPassword: "새 비밀번호를 한 번 더 입력하세요",
        pwLessThan8: "비밀번호는 8자리 이상이어야합니다",
        save: "저장",
        signOut: "로그아웃"
      },
      resetpassword: {
        sendRecoveryLink: "복구 이메일 보내기",
        enterEmail: "이메일 주소를 입력하세요",
        send: "보내기",
        backtoSignin: "로그인으로 돌아가기"
      },
      daolevel: {
        level: "레벨"
      },
      email_verification: {
        sendEmail: "이메일 보내기",
        send: "보내기",
        activate: "활성화",
        emailVerification: "이메일 인증",
        verifyEmail: "이메일 인증하기",
        sendVerificationEmail: "인증 이메일 보내기",
        confirmEmail: "이메일을 확인하세요",
        enterEmail: "이메일을 입력하세요",
        failed: "실패하였습니다"
      },
      otp: {
        enabled: "활성화되었습니다",
        failed: "실패하였습니다",
        twoFaVerification: "2FA 인증",
        noticeTwoFa:
          "2FA 인증을 활성화 하면 보다 안전하게 다오월렛을 사용하실 수 있습니다.계정의 보안을 강화하기 위해서 가능한 옵션들을 고려하시길 바랍니다. 계정을 안전하게 사용하실 수 있도록 다오월렛 팀은 최선을 다하겠습니다.",
        verifyGoogle2FA: "구글 2FA 인증하기",
        googleVerification: "구글 인증",
        firstStep: "1/2 단계",
        secondStep: "2/2 단계",
        scanQRcode: "구글 인증을 이용해서 QR코드를 스캔하세요",
        qrcode: "QR 코드",
        enterCode: "구글 인증 앱에 보이는 숫자 여섯자리를 입력하세요",
        confirm: "확인"
      },
      pending: {
        transactionPending: "보류 중인 거래 내역",
        numberofPending: "보류 중인 거래 내역의 갯수"
      },
      popup: {
        confirm: "확인"
      },
      send_transaction: {
        withdraw: "출금",
        deductDao: "다오 갯수가 차감됩니다",
        fee: "인출 수수료: ",
        sendToken: "토큰 전송이 실행됩니다",
        submitting: "전송중",
        success: "성공",
        transacionHash: "전송 해시 :",
        failed: "실패하였습니다",
        sending: "전송중",
        gasprice: "가스 가격",
        send: "보내기",
        sentSuccessfully: "성공적으로 전송하였습니다",
        gasUsed: "사용된 가스 : ",
        checkPending: "보류 중인 거래가 있는지 확인하세요",
        daotoken: "Dao 토큰",
        to: "받는 주소",
        send: "보내기",
        notice: "주의",
        withdrawDeductsDao: "이 토큰을 출금하면 다오 토큰이 차감됩니다",
        address: "주소",
        amount: "금액",
        gwei:
          "해당 링크(https://ethgasstation.info/)에서 현재 시세를 확인하고 가스 비용을 입력하세요. 빠른 전송을 위해서 현재 시세보다 조금 높은 Gwei 값을 입력할 것을 추천합니다",
        otpcode: "OTP 코드",
        close: "닫기",
        send: "전송",
        kycRequired: "KYC가 필요합니다",
        daoWalletTeam: "- Dao 지갑",
        kycRequiredforTransaction:
          "토큰을 전송하기 위해서는 KYC 승인이 필요합니다",
        aidaosendingwarning: "AiDAO 출금시 이에 비례하여 모든 에어드랍된 토큰도 함께 줄어듭니다. 자세한 정보는 정보 페이지를 참고하시길 바랍니다",
        deductToken: "모든 에어 드롭 토큰이 공제됩니다. 확실합니까?",
      },
      wallet_address: {
        addressCopied: "주소가 클립보드에 복사되었습니다",
        walletAddress: "지갑 주소",
        copy: "복사"
      },
      withdraw: {
        withdraw: "출금",
        daoTokenisUtilityToken:
          "토큰은 다오토큰 유저를 위한 유틸리티 토큰입니다.",
        withdrawDeductsDao: "이 토큰을 출금하면 다오 토큰이 차감됩니다",
        learnMore: "더 알아보기"
      },
      aidao: {
        balance: "잔액",
        back: "돌아가기"
      },
      cobinhood: {
        balance: "잔액",
        back: "돌아가가"
      },
      cybermiles: {
        balance: "잔액",
        back: "돌아가기"
      },
      ethereum: {
        balance: "잔액",
        back: "돌아가기"
      },
      dash: {
        balance: "잔액",
        back: "돌아가기"
      },
      golem: {
        balance: "잔액",
        back: "돌아가기"
      },
      wandx: {
        balance: "잔액",
        back: "돌아가기"
      },
      xdce: {
        balance: "잔액",
        back: "돌아가기"
      },
      xyo: {
        balance: "잔액",
        back: "돌아가기"
      },
      swapcenter: {
        address: "주소",
        amount: "금액",
        otpcode: "OTP코드"
      },
      tokenpage: {}
    }
  }
];

module.exports = data;



// WEBPACK FOOTER //
// ./src/components/data/content.js